<template>
    <div>
        <el-form class="form" ref="form" label-width="80px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="显示翻译" style="margin-bottom:12px;">
                <el-radio-group v-model="data">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import attributeMixin from '../../mixins/graphic/attribute'
export default {
    name: 'ShowTranslation',
    mixins: [attributeMixin],
    data() {
        return {
            type: 'ShowTranslation',
            default: 0,
        }
    },
    methods: {
        init() {
            this.checked = this.value.checked
            this.data = parseInt(this.value.value)
            if (this.data == null) {
                this.data = 0
            }
        },
    }
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}
</style>